







































import { Component, Vue } from "vue-property-decorator";

import card from "@/components/Card.vue";
import game from "@/game.ts";

const right = new Audio(require("@/assets/right.wav"));
const wrong = new Audio(require("@/assets/wrong.wav"));
const dice = new Audio(require("@/assets/dice.wav"));

right.volume = 0.4;
wrong.volume = 0.4;
dice.volume = 0.3;

const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

@Component
export default class extends Vue {
  showDice: boolean = true;
  oldPos: number = 0;
  enableDice: boolean = true;
  showCard: boolean = false;

  diceFaces = [
    { num: 1, face: "&#9856;" },
    { num: 2, face: "&#9857;" },
    { num: 3, face: "&#9858;" },
    { num: 4, face: "&#9859;" },
    { num: 5, face: "&#9860;" },
    { num: 6, face: "&#9861;" }
  ];
  face = { num: 1, face: "&#9856;" };

  get pos() {
    return game.pos;
  }

  get card() {
    return game.card;
  }

  async resp(awnser: string | boolean) {
    if (this.card.answer == awnser) {
      right.play();
      this.oldPos = this.card.prize;
      this.showCard = false;
      await game.move({ amount: this.card.prize, direction: 1 });
      if (this.card.prize == 0) {
        this.showDice = true;
        this.showCard = false;
      } else {
        this.showDice = false;
        this.showCard = true;
        game.setCard();
      }
    } else {
      wrong.play();
      this.showCard = false;
      await game.move({ amount: this.oldPos, direction: -1 });
      this.showDice = true;
    }
  }

  async roll(acc: number) {
    this.enableDice = false;
    for (let i = acc; i > 0; i--) {
      let rand = Math.round(Math.random() * 5);
      if (this.diceFaces[rand] == this.face) rand++;
      dice.play();
      this.face = this.diceFaces[rand];
      await sleep(400);
    }
    this.oldPos = this.face.num;
    this.showDice = false;
    this.enableDice = true;

    if ((await game.move({ amount: this.face.num, direction: 1 })) == 0) {
      game.setCard();
      this.showCard = true;
    }
  }
}
